import { C8Node } from "csi/typings";
import { Box, FlexColumn } from "designSystem/index";
import { grey } from "designSystem/styles/color";
import React, { FunctionComponent } from "react";
import { HiggMaterialComposition } from "src/HiggConnect/HiggMaterial/HiggMaterialStore";
import CalculationSection from "./CalculationSection";
import { CompositionMaterial, createCompositionKey } from "./Composition/CompositionStore";
import HintSection from "./HintSection";

export interface SingleItemProps {
	item: HiggMaterialComposition | CompositionMaterial;
}

/**
 * Props for the MaterialCompositionDrawer component.
 */
interface MaterialCompositionDrawerProps {
	/** the function to clear the composition and pass to calculation */
	clearComposition: VoidFunction;

	/** displays the satifaction status of the hint */
	compositionGuidanceSatisfied: string;

	/** list of all compositions currently in drawer */
	compositions: CompositionMaterial[] | HiggMaterialComposition[];

	/** count of items in drawer */
	count: number;

	/** color of hint */
	hint: { color: string };

	/** title of hint section */
	hintTitle: string;

	/** the current parent technical composition attribute that is being modified */
	parentTechnicalComposition: C8Node | null;

	/** The name of the single item component to be loaded into the drawer */
	SingleItemComponent: FunctionComponent<SingleItemProps>;
}
const MaterialCompositionDrawer: FunctionComponent<MaterialCompositionDrawerProps> = (props) => {
	const { 
		clearComposition, 
		compositionGuidanceSatisfied, 
		compositions, 
		count, 
		parentTechnicalComposition, 
		hint, 
		hintTitle, 
		SingleItemComponent,
	} = props;  
	return (
		<FlexColumn
			growNoOverflow
			p={4}
			sx={{ backgroundColor: grey[200] }}
		>
			<HintSection 
				compositionGuidanceSatisfied={compositionGuidanceSatisfied}
				count={count}
				hint={hint}
				hintTitle={hintTitle}
			/>
			<Box
				flexGrow={1}
				overflow="auto"
				pr={4}
			>
				{compositions?.map((composition, index) => {
					const key = createCompositionKey(
						composition.compositionMaterialUrl,
						parentTechnicalComposition?.Id,
					);
					return ( 
						<SingleItemComponent
							item={composition}
							key={key}
						/>
					);
				})}
			</Box>
			<Box borderTop={`2px solid ${grey[400]}`} />
			<CalculationSection 
				clearComposition={clearComposition}
				count={count}
			/>
		</FlexColumn>
	);
};
export default MaterialCompositionDrawer;